import React from "react";
import { Box, Typography, FormLabel } from "@mui/material";

const StoreSelector = ({ stores, selectedStore, setSelectedStore }) => {
  if (!stores.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Loading store locations...
      </Typography>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      <FormLabel sx={{ fontWeight: "bold" }}>
        Which location are you placing the order from?
      </FormLabel>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mt: 1,
          flexWrap: "wrap",
          justifyContent: "center",
        }}>
        {stores.map((store) => (
          <Box
            key={store._id}
            onClick={() => setSelectedStore(store.displayName)}
            sx={{
              flex: "1 1 200px",
              maxWidth: 300,
              px: 2,
              py: 1.5,
              border: "1px solid",
              borderColor:
                selectedStore === store.displayName
                  ? "primary.main"
                  : "grey.300",
              borderRadius: 2,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 500,
              color:
                selectedStore === store.displayName
                  ? "primary.main"
                  : "text.primary",
              transition: "all 0.2s ease-in-out",
              boxShadow:
                selectedStore === store.displayName
                  ? "0 0 0 1px rgba(0,0,0,0.05)"
                  : "none",
              "&:hover": {
                boxShadow: "0 0 0 2px rgba(0,0,0,0.05)",
              },
              textAlign: "center",
              backgroundColor:
                selectedStore === store.displayName
                  ? "rgba(0,0,0,0.02)"
                  : "transparent",
            }}>
            {store.displayName}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StoreSelector;
